module.exports = __webpack_public_path__ + "fonts/f51e7cdb48cde72df55be8f43de6f044.svg";